
import { createElement } from "react";
import React from "react";
import { useTranslation } from "react-i18next";
import { OnTableRowClick$1, ColumnDefinition$1, CellContent } from "../../../Widgets/Table/Types.js";
import { withoutOnboardingTourQueryParams, isInspectionOnboardingPhase, formatReminderInterval } from "../../../Common.js";
import { join } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { reactApi, reactElement } from "../../../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { createObj } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { Button } from "../../../Components/Button.js";
import Shipment_Add from "../../../../public/assets/icons/Shipment_Add.svg";
import { RouterModule_encodeQueryString, RouterModule_encodeParts, RouterModule_nav } from "../../../fable_modules/Feliz.Router.4.0.0/Router.fs.js";
import { length, isEmpty, singleton, toArray, empty, ofArray } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { Table } from "../../../Widgets/Table/Table.js";
import { React_useElmish_Z6C327F2E } from "../../../fable_modules/Feliz.UseElmish.2.5.0/UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../../../fable_modules/Fable.Elmish.5.0.2/program.fs.js";
import { update as update_1, init as init_1 } from "./State.js";
import { Skeleton } from "../../../Components/Skeleton.js";
import { InformationAlert } from "../../../Components/Alert.js";
import { TourGuideLocale, TourGuide, TourStep } from "../../../Components/TourGuide.js";
import { empty as empty_1, singleton as singleton_1, append, delay, toList } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import Multiple_File_1 from "../../../../public/assets/icons/Multiple_File_1.svg";
import { Msg } from "./Types.js";

function InspectionTemplateTable(props) {
    let elems_2, elems_1, elems, Label;
    const t = useTranslation()[0];
    const columnDefinitions = [new ColumnDefinition$1("name", "", t("inspection_template.name"), (dto) => (new CellContent(0, [dto.Name])), "text", "text"), new ColumnDefinition$1("description", "", t("inspection_template.description"), (dto_1) => (new CellContent(0, [dto_1.Description])), "text", "text"), new ColumnDefinition$1("interval", "", t("inspection_template.interval"), (dto_2) => (new CellContent(0, [formatReminderInterval(t, dto_2.Interval, dto_2.CustomInterval)])), "select", "text"), new ColumnDefinition$1("successful_results", "", t("inspection_template.successful_results"), (dto_3) => (new CellContent(0, [join(", ", dto_3.SuccessfulResults)])), "none", "text"), new ColumnDefinition$1("failed_results", "", t("inspection_template.failed_results"), (dto_4) => (new CellContent(0, [join(", ", dto_4.FailedResults)])), "none", "text")];
    return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "grow"])], (elems_2 = [reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-row", "mb-3", "justify-items-end"])], (elems_1 = [reactElement("div", {
        className: join(" ", ["grow"]),
    }), reactElement("div", createObj(ofArray([["className", join(" ", ["justify-self-end"])], (elems = [createElement(Button, (Label = t("inspection_template.create"), {
        ComponentState: "enabled",
        Icon: Shipment_Add(),
        Label: Label,
        OnClick: () => {
            RouterModule_nav(ofArray(["inspection-templates", "new"]), 1, 1);
        },
        TestId: "create-inspection-template-button",
        Variant: "primary",
    }))], ["children", reactApi.Children.toArray(Array.from(elems))])])))], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))), createElement(Table, {
        ColumnDefinitions: columnDefinitions,
        Controls: empty(),
        Options: {
            BorderStyle: "row",
            CSVDownload: false,
            ConfigurableColumns: false,
            CustomTableFilters: false,
            DefaultSortColumn: ["name", "asc"],
            Fullscreen: false,
            GlobalSearch: true,
            OnRowClick: new OnTableRowClick$1(1, [(dto_5) => RouterModule_encodeParts(ofArray(["inspection-templates", dto_5.Id]), 1)]),
            RowSelection: "disabled",
            SaveTableConfiguration: false,
        },
        TableKey: "inspection-templates-table",
        TableRows: toArray(props.Templates),
    })], ["children", reactApi.Children.toArray(Array.from(elems_2))])])));
}

export function OverviewView(props) {
    let elems, elems_3;
    const t = useTranslation()[0];
    const patternInput_1 = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(init_1, update_1, (_arg, _arg_1) => {
    }), undefined, undefined);
    const state_1 = patternInput_1[0];
    const dispatch = patternInput_1[1];
    const patternInput_2 = reactApi.useState(false);
    const setInspectionTourDismissed = patternInput_2[1];
    const componentState = state_1.FormState.IsLoading ? "disabled" : "enabled";
    const showInspectionTour = (isInspectionOnboardingPhase() && !patternInput_2[0]) && props.AccountSettings.InspectionsEnabled;
    const clearInspectionTourFromUrl = () => {
        RouterModule_nav(singleton("inspection-templates" + RouterModule_encodeQueryString(withoutOnboardingTourQueryParams())), 1, 1);
    };
    const matchValue = state_1.Templates;
    if (matchValue.tag === 0) {
        return createElement(Skeleton, {
            Variant: "table",
        });
    }
    else {
        const templates = matchValue.fields[0];
        if (!props.AccountSettings.InspectionsEnabled) {
            return reactElement("div", createObj(ofArray([["className", join(" ", ["w-10/12"])], (elems = [createElement(InformationAlert, {
                Label: "inspection_template.not_included",
            })], ["children", reactApi.Children.toArray(Array.from(elems))])])));
        }
        else {
            const inspectionSteps = !showInspectionTour ? empty() : (isEmpty(templates) ? ofArray([new TourStep("[data-test-id=\'onboarding-inspection-template-import-area\']", t("onboarding.tour.inspection_predefined_title"), reactElement("div", {
                children: t("onboarding.tour.inspection_predefined_content"),
            }), "bottom", true), new TourStep("[data-test-id=\'create-inspection-template-button-empty\']", t("onboarding.tour.inspection_create_title"), reactElement("div", {
                children: t("onboarding.tour.inspection_create_content"),
            }), "bottom", true)]) : singleton(new TourStep("[data-test-id=\'create-inspection-template-button\']", t("onboarding.tour.inspection_create_title"), reactElement("div", {
                children: t("onboarding.tour.inspection_create_content"),
            }), "bottom", true)));
            return reactElement("div", createObj(ofArray([["className", join(" ", ["h-full"])], (elems_3 = toList(delay(() => {
                let elems_2, elems_1, Label, Label_1;
                return append(isEmpty(templates) ? singleton_1(reactElement("div", createObj(ofArray([["data-test-id", "onboarding-inspection-template-import-area"], ["className", join(" ", ["flex", "flex-col", "items-center", "gap-4", "py-8"])], (elems_2 = [reactElement("div", {
                    className: join(" ", ["text-text-muted", "text-center"]),
                    children: t("inspection_template.empty_state"),
                }), reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "gap-3"])], (elems_1 = [createElement(Button, (Label = t("inspection_template.load_predefined"), {
                    ComponentState: componentState,
                    Icon: Multiple_File_1(),
                    Label: Label,
                    OnClick: () => {
                        dispatch(new Msg(2, []));
                    },
                    TestId: "load-predefined-templates-button",
                    Variant: "secondary",
                })), createElement(Button, (Label_1 = t("inspection_template.create"), {
                    ComponentState: componentState,
                    Icon: Shipment_Add(),
                    Label: Label_1,
                    OnClick: () => {
                        RouterModule_nav(ofArray(["inspection-templates", "new"]), 1, 1);
                    },
                    TestId: "create-inspection-template-button-empty",
                    Variant: "primary",
                }))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))], ["children", reactApi.Children.toArray(Array.from(elems_2))])])))) : singleton_1(createElement(InspectionTemplateTable, {
                    Dispatch: dispatch,
                    Templates: templates,
                })), delay(() => {
                    let ScrollFirstStep;
                    return !isEmpty(inspectionSteps) ? singleton_1(createElement(TourGuide, (ScrollFirstStep = (length(inspectionSteps) === 1), {
                        IsRunning: true,
                        Locale: new TourGuideLocale(t("onboarding.tour.joyride_back"), t("onboarding.tour.joyride_close"), t("onboarding.tour.joyride_last"), t("onboarding.tour.joyride_next"), t("onboarding.tour.joyride_next_with_progress"), t("onboarding.tour.joyride_open"), t("onboarding.tour.joyride_skip")),
                        OnFinish: () => {
                            setInspectionTourDismissed(true);
                            clearInspectionTourFromUrl();
                        },
                        OnSkip: () => {
                            setInspectionTourDismissed(true);
                            clearInspectionTourFromUrl();
                        },
                        ScrollFirstStep: ScrollFirstStep,
                        Steps: inspectionSteps,
                    }))) : empty_1();
                }));
            })), ["children", reactApi.Children.toArray(Array.from(elems_3))])])));
        }
    }
}

